import type { AppIconProps } from "../IconTypes";

export const RootFolderIcon: React.FC<AppIconProps> = ({
  width = 16,
  height = 16,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.7421 4.5H20.7151C21.132 4.49996 21.5443 4.5868 21.9257 4.75499C22.3072 4.92317 22.6494 5.16902 22.9305 5.47683C23.2117 5.78465 23.4256 6.14768 23.5586 6.54276C23.6916 6.93785 23.7408 7.35633 23.7031 7.7715L22.7476 18.2715C22.6798 19.0169 22.3359 19.71 21.7834 20.2148C21.2308 20.7197 20.5095 20.9997 19.7611 21H4.23757C3.48913 20.9997 2.76783 20.7197 2.21527 20.2148C1.66271 19.71 1.31881 19.0169 1.25107 18.2715L0.295574 7.7715C0.23293 7.07678 0.41433 6.38194 0.808574 5.8065L0.750074 4.5C0.750074 3.70435 1.06614 2.94129 1.62875 2.37868C2.19136 1.81607 2.95442 1.5 3.75007 1.5H9.25807C10.0537 1.50017 10.8166 1.81635 11.3791 2.379L12.6211 3.621C13.1836 4.18365 13.9465 4.49983 14.7421 4.5ZM2.25907 4.68C2.58107 4.561 2.92307 4.501 3.28507 4.5H11.3791L10.3186 3.4395C10.0373 3.15818 9.65587 3.00008 9.25807 3H3.75007C3.35714 2.99993 2.97986 3.15405 2.69936 3.42922C2.41887 3.70439 2.25754 4.07864 2.25007 4.4715L2.25907 4.68Z"
        fill="#59C69E"
      />
    </svg>
  );
};
